import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigurationService } from 'src/app/core/services/app-configuration.service';
import { Approbation } from '../models/approbation.model';

@Injectable({
    providedIn: 'root'
})
export class ApprobationService {

    private apiURL : string;

    constructor(private http: HttpClient, private appConfigurationService: AppConfigurationService) {

        this.apiURL = this.appConfigurationService.baseApi + '/approbation';

    }

    getByEdition(editionId: number): any {

        const url = this.apiURL + '/edition/' + editionId;
        return this.http.get<Approbation[]>(url);

    }

    getByEnrollment(enrollmentId: number): any {

        const url = this.apiURL + '/enrollment/' + enrollmentId;
        return this.http.get<Approbation[]>(url);

    }

}
